module.exports = __webpack_public_path__ + "static/media/doTERRA-launch-guide.6c5b3bed.png";